import { c as _c } from "react/compiler-runtime";
import type { DocumentRequestConfig, TimelineWorkflowRequestConfig, WorkflowTriggered } from '@onefootprint/request-types/dashboard';
import { Trans, useTranslation } from 'react-i18next';
import { OnboardingTraceLink } from '@/components';
import Actor from '../actor/actor';
type WorkflowTriggeredEventHeaderProps = {
  data: WorkflowTriggered;
};
const WorkflowTriggeredEventHeader = t0 => {
  const $ = _c(25);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.workflowTriggeredEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = config => {
      if (!config) {
        return t(_temp);
      }
      if (config.kind === "onboard") {
        return t(_temp2);
      }
      if (config.kind === "document") {
        const {
          configs,
          businessConfigs: t3
        } = config.data;
        const businessConfigs = t3 === undefined ? [] : t3;
        const allDocConfigs = [...configs, ...businessConfigs];
        const displayForConfig = config_0 => {
          if (config_0.kind === "identity") {
            if (config_0.data.collectSelfie) {
              return `${t(_temp3)} ${t(_temp4)}`;
            }
            return t(_temp5);
          }
          if (config_0.kind === "custom") {
            return config_0.data.name;
          }
          if (config_0.kind === "proof_of_address") {
            return t(_temp6);
          }
          if (config_0.kind === "proof_of_ssn") {
            return t(_temp7);
          }
        };
        const formattedActions = allDocConfigs.map(displayForConfig).join(", ");
        return t(_temp8, {
          docConfigs: formattedActions
        });
      }
      return "";
    };
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getActionName = t2;
  let t3;
  if ($[3] !== data.config || $[4] !== getActionName) {
    t3 = getActionName(data.config);
    $[3] = data.config;
    $[4] = getActionName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const action = t3;
  let t4;
  if ($[6] !== action) {
    t4 = {
      action
    };
    $[6] = action;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== data) {
    t5 = <PlaybookContext data={data} />;
    $[8] = data;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== data.actor) {
    t6 = <Actor actor={data.actor} />;
    $[10] = data.actor;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = {
      playbook: t5,
      actor: t6
    };
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t7) {
    t8 = <Trans ns="entity-details" i18nKey={_temp9} values={t4} components={t7} />;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== data.isCompleted || $[19] !== data.requestIsActive || $[20] !== t) {
    t9 = !data.requestIsActive && !data.isCompleted && <><div className="inline items-center justify-center mx-1 md:flex md:mx-0.5">·</div><span className="text-body-2 text-tertiary">{t(_temp10)}</span></>;
    $[18] = data.isCompleted;
    $[19] = data.requestIsActive;
    $[20] = t;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8 || $[23] !== t9) {
    t10 = <div className="text-body-2 text-tertiary md:flex md:gap-1">{t8}{t9}</div>;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
const PlaybookContext = t0 => {
  const $ = _c(2);
  const {
    data
  } = t0;
  if (data.config?.kind !== "onboard") {
    return null;
  }
  let t1;
  if ($[0] !== data.config.data.playbook) {
    t1 = <OnboardingTraceLink playbook={data.config.data.playbook} />;
    $[0] = data.config.data.playbook;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default WorkflowTriggeredEventHeader;
function _temp($) {
  return $.actions.legacy;
}
function _temp2($_0) {
  return $_0.actions.onboard;
}
function _temp3($_1) {
  return $_1.actions.id_document;
}
function _temp4($_2) {
  return $_2.actions.andSelfie;
}
function _temp5($_3) {
  return $_3.actions.id_document;
}
function _temp6($_4) {
  return $_4.actions.proof_of_address;
}
function _temp7($_5) {
  return $_5.actions.proof_of_ssn;
}
function _temp8($_6) {
  return $_6.actions.document;
}
function _temp9($_7) {
  return $_7.auditTrail.timeline.workflowTriggeredEvent.userRequestedTo;
}
function _temp10($_8) {
  return $_8.canceled;
}